const getPaymentContactPersonId = (state: any) =>
  state.getIn(['paymentSettings', 'data', 'contactPersonId']);

export default getPaymentContactPersonId;
